export default function getIdFromSlug(slug) {
  if (!slug) {
    return null;
  }
  const index = slug.lastIndexOf('-');
  const roomId = slug.substring(index + 1);
  return roomId;
}
